import React from 'react';

import { NavLink } from 'components/mobile-web-navigation-bar/helpers';
import { NavLinkText } from 'components/mobile-web-navigation-bar/styled';
import SkipToContent from 'components/skip-content';
import UniversalLink from 'components/universal-link';

import type { ILeftNavProps } from './types';

const StyledNavLink = NavLink.withConfig({
  marginLeft: '$5',
  _web: {
    cursor: 'pointer',
  },
});

const StyledNavLinkText = NavLinkText.withConfig({
  variant: 'copyTwo',
  fontSize: 'sm',
  fontWeight: 'bold',
});

export const LeftNav = ({ navLinks }: ILeftNavProps) => {
  return (
    <>
      <SkipToContent />
      {navLinks.map(navLink => (
        <UniversalLink
          to={navLink.link}
          key={navLink.key}
          data-testid={navLink.text}
          internal={{
            component: StyledNavLink,
            props: {
              to: navLink.link,
              requiresExactMatch: true,
              component: (isActive: boolean) => (
                <StyledNavLinkText $isActive={isActive}>{navLink.text}</StyledNavLinkText>
              ),
            },
          }}
          external={{
            component: StyledNavLink,
            props: {
              to: navLink.link,
              component: () => <StyledNavLinkText>{navLink.text}</StyledNavLinkText>,
            },
          }}
        >
          {navLink.text}
        </UniversalLink>
      ))}
    </>
  );
};
